import { render } from "./Transfer-Notes-List.vue?vue&type=template&id=c4eef096&scoped=true"
import script from "./Transfer-Notes-List.vue?vue&type=script&lang=js"
export * from "./Transfer-Notes-List.vue?vue&type=script&lang=js"

import "./Transfer-Notes-List.vue?vue&type=style&index=0&id=c4eef096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4eef096"]])

export default __exports__